import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../reducers/authSlice';
import editorReducer from '../reducers/editorSlice';
import emptySplitApi from '../utils/rtk';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    editor: editorReducer,
    [emptySplitApi.reducerPath]: emptySplitApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(emptySplitApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
